<div class="flex flex-col gap-[1.25rem]">
  <div class="main flex items-center justify-between  h-[4.75rem]">
    <!-- LEFT SELECTOR AND INPUT -->
    <div class="flex flex-row gap-[1.75rem]">
      <div class="w-[35rem] bg-black-3 h-[2.5rem] rounded-[0.5rem]"></div>
      <div class="flex flex-row gap-[1rem]">
        <div class="w-[7rem] bg-black-1 h-[2.5rem] rounded-[0.5rem]"></div>
        <div class="w-[7rem] bg-black-1 h-[2.5rem] rounded-[0.5rem]"></div>
      </div>

    </div>
    <!-- RIGHT BUTTONS -->
    <div class="flex flex-row gap-0.46875">
      <div class="w-[6rem] bg-black-1 h-[1.85rem] rounded-[1.5rem]"></div>
      <div class="w-[6rem] bg-black-1 h-[1.85rem] rounded-[1.5rem]"></div>
      <div class="w-[7rem] bg-black-1 h-[1.85rem] rounded-[1.5rem]"></div>
      <div class="w-[5rem] bg-black-3 h-[1.85rem] rounded-[1.5rem]"></div>
      <div class="w-[8.55rem] bg-black-3 h-[1.85rem] rounded-[1.5rem]"></div>
    </div>
  </div>

  <!-- TABLE  -->
  <div class="main">
    <app-bm-loading-table/>
  </div>
  <!-- ANALYTICS  -->
  <div class="main flex flex-col h-[40rem] gap-[1rem]">
    <!-- Top cards   -->
    <div class="flex flex-row gap-0.46875">
      @for (i of [].constructor(6); track $index) {
        <div class="w-full bg-black-2 h-[5rem] rounded-[0.5rem]"></div>
      }
    </div>
    <!-- Charts  -->
    <div class="flex flex-row gap-[1rem]">
      <div class="w-full bg-black-2 h-[32rem] rounded-[0.5rem]"></div>
      <div class="w-[56%] bg-black-2 h-[32rem] rounded-[0.5rem]"></div>
    </div>
  </div>
</div>
